import React from 'react';
import { UtensilsCrossed } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * Widget for Kitchen domain navigation card
 * Navigates to kitchen view
 */
export default function KitchenCardWidget({ onNavigate }) {
  return (
    <button
      onClick={() => onNavigate && onNavigate('kitchen')}
      style={{
        width: '100%',
        padding: '16px 12px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.15s ease'
      }}
    >
      <UtensilsCrossed size={24} color="#F97316" />
      <span style={{
        fontSize: '13px',
        fontWeight: '600',
        color: ABLE_COLORS.textPrimary
      }}>
        Kitchen
      </span>
      <span style={{
        fontSize: '10px',
        color: ABLE_COLORS.textMuted
      }}>
        What's cooking?
      </span>
    </button>
  );
}
